import { reactive, computed } from '@vue/composition-api'
import { checkEmailFormat } from '@/util/validation'
import * as _ from 'lodash'

export const ContractAccountCreate = (props, context) => {
  const store = context.root.$store
  const { contract } = store.state
  store.dispatch('contract/getContractData')

  const state = reactive({
    authShow: false,
    name: '',
    email: '',
    emailConfirm: '',
    auth: 0
  })


  const validation = reactive({
    isSubmit: false,
    name: {
      require: computed(() => state.name !== '')
    },
    email: {
      require: computed(() => state.email !== ''),
      format: computed(() => checkEmailFormat(state.email))
    },
    emailConfirm: {
      require: computed(() => state.email === '' || (state.email !== '' && state.emailConfirm !== '')),
      same: computed(() => state.email === '' || (state.email !== '' && state.email === state.emailConfirm))
    },
    all: computed(() => {
      // 決定ボタン押下前(isSubmit:false)の場合はチェックしない
      return validation.isSubmit &&
        validation.name.require &&
        validation.email.require &&
        validation.email.format &&
        validation.emailConfirm.require &&
        validation.emailConfirm.same
    })
  })

  const close = () => {
    context.emit('closeCreate')
  }
  const submit = () => {
    validation.isSubmit = true
    if (validation.all) {
      const { authShow, ...user } = state
      context.emit('submit', user)
    }
  }

  return {
    close,
    submit,
    state,
    validation
  }
}
